<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="['field_name', 'department', 'com_name', 'writer_name', 'date']" />
    <div>
      <h5 class="my-4"><i class="dot"></i>{{ $t("공지사항") }}</h5>

      <div class="writeGridContainer">
        <div>
          <div>{{ $t("교육일") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.교육일 }}</p>
          <date-selector v-else v-model="form.교육일" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t("교육시간") }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.교육시간.sTime }} ~ {{ form.교육시간.eTime }}</p>
          <time-selector-rang v-else :readonly="board.readonly" class="flex" v-model="form.교육시간" />
        </div>
        <div>
          <div>{{ $t("교육장소") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.교육장소 }}</p>
          <ml-input v-else class="w-full flex-1" v-model="form.교육장소" :readonly="board.readonly" />
        </div>
      </div>

      <h5 class="my-4"><i class="dot"></i>{{ $t("교육내용") }}</h5>
      <div>
        <div v-if="isPrint" class="print-textarea">{{ form.교육내용 }}</div>
        <ml-textarea v-else class="w-full" rows="5" v-model="form.교육내용" :readonly="board.readonly" />
      </div>

      <!--    사진대지-->
      <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" :section-title="$t('위험성평가 교육 실시사진')" :placeholder="$t('위험성평가 교육 실시사진')" />

      <AttendeeTableTwoColumn v-model="form.참석자명단" :board="board" :is-print="isPrint" class="mt-28px" :title="$t('참석자 명단')" />

      <file-upload-module v-if="!isPrint" v-model="form.fileList" class="w-full" :isPrint="isPrint" :readonly="board.readonly" />
    </div>
  </div>
</template>

<script>
import RadioGroup from "@/components/radio/RadioGroup.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import AttendeeTableTwoColumn from "@/components/AttendeeTableTwoColumn.vue";
import TimeSelectorRang from "@/components/selector/TimeSelectorRang.vue";

export default {
  components: {
    TimeSelectorRang,
    AttendeeTableTwoColumn,
    DateSelectorRang,
    RadioGroup,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  async created() {},
  data() {
    return {
      form: {
        stdInfo: {},
        교육일: "",
        교육시간: {},
        교육장소: "",
        교육내용:
          "(예시) 수급업체 위험성평가 실시를 위한 사전준비\n- 사업장 안전보건정보 및 아차사고 사례 공유를 통한 작업장 내 유해·위험요인 탐색\n- 업체별 기계설비 및 유해·위험물질 사용현황 등 파악\n- 수급업체 위험성평가 실시절차 안내\n" +
          "(예시) 수급업체 위험성평가 결과보고 작성 매뉴얼\n- 도출된 유해·위험요인에 대한 위험성 추정 및 결정방법\n- 위험성 감소대책 수립 방법 안내\n" +
          "(예시) 작업중지 요청제 및 위험작업 허가제\n- 공단 작업중지 요청센터 및 작업중지 요청절차 안내\n- 공단 위험작업 허가절차 및 허가 연장 절차 안내",
        참석자명단: [],

        photoList: [],
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    isMobile() {
      return this.$store.state.windowWidth <= 768;
    },
  },
};
</script>
